import * as Yup from "yup";

export const billingReportSchema = Yup.object().shape({
  startDate: Yup.string()
    .required("Start Date is required")
    .test(
      "is-before-end",
      "Start Date cannot be after End Date",
      function (startDate) {
        const { endDate } = this.parent;
        return endDate ? new Date(startDate) <= new Date(endDate) : true;
      }
    ),
  endDate: Yup.string()
    .required("End Date is required")
    .test(
      "is-after-start",
      "End Date cannot be before Start Date",
      function (endDate) {
        const { startDate } = this.parent;
        return startDate ? new Date(endDate) >= new Date(startDate) : true;
      }
    ),
});
